import i18n, { setLanguage } from './index';

// Switches this browser at once, then records the choice on the account so it follows the user
// to another device. Resolves false when the switch worked but the save did not.
export async function chooseLanguage(code, { signedIn }) {
    await setLanguage(code);
    if (!signedIn || code === 'xx') {
        return true;
    }
    try {
        const response = await fetch('api/identity/updatelanguage', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ language: code })
        });
        return response.ok;
    } catch {
        return false;
    }
}

// Given the getuser response: the account's saved language wins over whatever this browser used
// last. A user who has never chosen (null) keeps the current language, so nobody is moved off
// English without choosing to be.
export function applyAccountLanguage(user) {
    if (user && user.language && user.language !== i18n.language) {
        setLanguage(user.language).catch(() => { });
    }
}
